// extracted by mini-css-extract-plugin
export default {"container":"FilteringInfo_container__E9Krr","info":"FilteringInfo_info__fUSud"};